import { Button, Form, Input, Space, notification } from 'antd'
import React, { useEffect, useState } from 'react'
import { GMOMultiPaymentScript } from '../../repositories/GMO/GMOMultiPaymentScript'
import { useCreatePaymentMethod } from '../../repositories/GMO/payment'
import { getShopIdApi } from '../../repositories/apiRepo'
import { useRecoilState } from 'recoil'
import { userProfileAtom } from '../../store/userProfile'
import { useNavigate } from 'react-router-dom'

const FormCard = () => {
  const { form, onCreatePaymentMethod } = useCreatePaymentMethod()
  const [shopId, setShopId] = useState('')
  const [logoCard, setLogoCard] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [userProfile] = useRecoilState(userProfileAtom)

  const navigate = useNavigate()

  const getCardType = (number: string) => {
    const re = {
      visa: /^4([0-9]{12})?(?:[0-9]{3})?/,
      mastercard:
        /^(5[1-5]([0-9]{14})?|2(22[1-9]([0-9]{12})?|2[3-9]([0-9]{13})?|[3-6]([0-9]{14})?|7[0-1]([0-9]{13})?|720([0-9]{12})?))/,
      amex: /^3[47]([0-9]{13})?/,
      diners: /^3(?:0[0-5]|[68][0-9])([0-9]{11})?/,
      jcb: /^(?:2131|1800|35\d{3})(\d{11})?/
    }
    for (const key in re) {
      if (re[key as keyof typeof re].test(number)) {
        return key
      }
    }

    return 'unknown'
  }

  const onChangeCardNumber = (e: React.ChangeEvent<HTMLInputElement>) => {
    const data = e.target.value
    const card = getCardType(data.replace(/-/g, ''))
    setLogoCard(card)
    if (!data) {
      return ''
    }

    if (/[^0-9-]/.test(data)) {
      return form.setFieldValue('cardNumber', '')
    }
    form.setFieldValue(
      'cardNumber',
      `${data
        .toString()
        .match(/(\d{4})|(\d{1,3})/gm)
        ?.join('-')}`
    )
  }

  const onChangeCardExpireAt = (e: React.ChangeEvent<HTMLInputElement>) => {
    const data = e.target.value
    if (!data) {
      return ''
    }

    if (/[^0-9/]/.test(data)) {
      return form.setFieldValue('cardExpireAt', '')
    }
    form.setFieldValue(
      'cardExpireAt',
      `${data
        .toString()
        .match(/(\d{1,2})|(\d{1,2})/gm)
        ?.join('/')}`
    )
  }

  const validatorCardEx = (_: any, value: string) => {
    const month = value?.toString().slice(0, 2)
    const year = value?.toString().slice(3)
    const current = new Date()

    const checkYear =
      new Date(parseInt(`20${year}`), parseInt(month) - 1) <
      new Date(current.getFullYear(), current.getMonth())
    if (parseInt(month) < 1 || parseInt(month) > 12) {
      return Promise.reject(
        new Error('月には1から12までの数字を指定してください。')
      )
    }
    if (checkYear) {
      return Promise.reject(
        new Error('有効期限には本年以降を指定してください。')
      )
    }
    return Promise.resolve()
  }

  useEffect(() => {
    const getShopId = async () => {
      try {
        const data = await getShopIdApi()
        if (data) {
          setShopId(data.data.shop_id)
        }
      } catch (error: any) {
        if (error?.response?.data?.error?.message) {
          notification.error({
            message: `エラー発生しました`,
            description: error.response.data.error.message
          })
        }
      }
    }
    if (userProfile) {
      getShopId()
    }
  }, [userProfile])

  useEffect(() => {
    const pointData = localStorage.getItem('point')
    if (!pointData) {
      navigate('/')
    }
  }, [])

  const logoCardImg = (
    <>
      {logoCard === 'visa' && <img src='/visa.svg' className='h-7' />}

      {logoCard === 'amex' && <img src='/amex.svg' className='h-7' />}

      {logoCard === 'jcb' && <img src='/jcb.svg' className='h-7' />}

      {logoCard === 'mastercard' && (
        <img src='/mastercard.svg' className='h-7' />
      )}

      {logoCard === 'diners' && <img src='/Diners-Club.jpg' className='h-7' />}
    </>
  )

  const onFinish = () => {
    setIsLoading(true)
    onCreatePaymentMethod(setIsLoading)
  }

  return (
    <>
      <Form
        form={form}
        layout='vertical'
        onFinish={onFinish}
        requiredMark={false}
        autoComplete='off'
      >
        {shopId && <GMOMultiPaymentScript apiKey={shopId} />}

        <Form.Item
          name='cardNumber'
          label='カード番号'
          rules={[
            { required: true, message: 'カード番号は必須項目です。' },
            { min: 14, message: '半角数字で14~16桁を入力してください。' }
          ]}
        >
          <Input
            inputMode='numeric'
            onChange={onChangeCardNumber}
            placeholder='XXXX-XXXX-XXXX-XXXX'
            maxLength={19}
            className='w-full'
            size='large'
            suffix={logoCardImg}
          />
        </Form.Item>

        <Form.Item
          name='cardExpireAt'
          label='有効期限'
          rules={[
            { required: true, message: '有効期限は必須項目です。' },
            { validator: validatorCardEx }
          ]}
        >
          <Input
            inputMode='numeric'
            onChange={onChangeCardExpireAt}
            placeholder='MM   /   YY'
            maxLength={5}
            className='w-48'
            size='large'
          />
        </Form.Item>
        <Form.Item className='flex justify-center'>
          <Space>
            <Button
              onClick={() => navigate('/')}
              disabled={isLoading}
              className='h-10 w-32 bg-[#6A6A6A]'
            >
              キャンセル
            </Button>
            <Button
              type='primary'
              loading={isLoading}
              htmlType='submit'
              className='h-10 w-32'
            >
              決済
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </>
  )
}
export default FormCard
